<template>
  <div>
    <div class="bg-white padding-ten-lr ">
      <b-row style="max-width:100%">
        <b-col xs="12" sm="12" md="12" lg="2">
          <h5 class="color-gray">
            <font-awesome-icon
              class="show-icon hidden-icons"
              icon="arrow-left"
            />
            Home
          </h5>
        </b-col>
      </b-row>
    </div>
    <div class="bg-white padding-five-all">
      <h5 class="color-orange">Dashboard</h5>
      <b-col cols="2">
        <b-form-group>
          <label class="color-orange margin-none">Filtro:</label>
          <b-form-select
            id="input-3"
            v-model="valueDate"
            :options="fechas"
            required
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-card-group deck class="margin-lr-none">
        <b-card header-tag="header" class="bg-os-red border-none">
          <b-row>
            <b-col cols="2" style="position:relative;">
              <div class="center-div">
                <font-awesome-icon
                  color="white"
                  icon="calendar-day"
                  style="font-size:25px;margin-right:15px"
                />
              </div>
            </b-col>
            <b-col cols="8" style="position:relative;">
              <h6 class="mb-0 color-white center-div">OS Pend. de creación</h6>
            </b-col>
            <b-col cols="2" style="position:relative;">
              <p class=" color-white text-large center-div">
                {{ dataDashboard.pendingPayment }}
              </p>
            </b-col>
          </b-row>
        </b-card>

        <b-card header-tag="header" class="bg-os-blue">
          <b-row>
            <b-col cols="2" style="position:relative;">
              <div class="center-div">
                <font-awesome-icon
                  color="white"
                  icon="calendar-day"
                  style="font-size:25px;margin-right:15px"
                />
              </div>
            </b-col>
            <b-col cols="8" style="position:relative;">
              <h6 class="mb-0 color-white center-div">
                OS <br />
                Coordinada
              </h6>
            </b-col>
            <b-col cols="2" style="position:relative;">
              <p class=" color-white text-large center-div">
                {{ dataDashboard.coordinate }}
              </p>
            </b-col>
          </b-row>
        </b-card>
        <b-card header-tag="header" class="bg-os-mostaza">
          <b-row>
            <b-col cols="2" style="position:relative;">
              <div class="center-div">
                <font-awesome-icon
                  color="white"
                  icon="calendar-day"
                  style="font-size:25px;margin-right:15px"
                />
              </div>
            </b-col>
            <b-col cols="8" style="position:relative;">
              <h6 class="mb-0 color-white center-div">
                OS <br />
                Realizada
              </h6>
            </b-col>
            <b-col cols="2" style="position:relative;">
              <p class=" color-white text-large center-div">
                {{ dataDashboard.completed }}
              </p>
            </b-col>
          </b-row>
        </b-card>
        <b-card header-tag="header" class="bg-os-green">
          <b-row>
            <b-col cols="2" style="position:relative;">
              <div class="center-div">
                <font-awesome-icon
                  color="white"
                  icon="calendar-day"
                  style="font-size:25px;margin-right:15px"
                />
              </div>
            </b-col>
            <b-col cols="7" style="position:relative;">
              <h6 class="mb-0 color-white center-div">
                OS No <br />
                realizada
              </h6>
            </b-col>
            <b-col cols="3" style="position:relative;">
              <p class=" color-white text-large center-div">
                {{ dataDashboard.unrealized }}
              </p>
            </b-col>
          </b-row>
        </b-card>
      </b-card-group>
    </div>
     <!--<div class="bg-white padding-five-all ">
      <h5 class="color-orange ">Historial OS</h5>
      <b-container fluid>
         User Interface controls 
        <b-row>
          <b-col cols="12">
            <label>Búsqueda</label>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="6" class="my-1">
            <label class="text-grey">Tipo de documento</label>
            <b-form-group>
              <b-form-select
                @change="clearParamsVal"
                v-model="selectedParams"
                size="md"
                :options="optionsParams"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col lg="6" class="my-1">
            <label class="text-grey">Número de documento</label>
            <b-form-group v-if="selectedParams == 'a'">
              <b-form-input
                type="text"
                v-model="valueParams"
                size="md"
                placeholder="Ingrese el valor"
              ></b-form-input>
            </b-form-group>
            <b-form-group v-else-if="selectedParams == 'b'">
              <b-form-input
                type="text"
                v-model="sellerNote"
                size="md"
                placeholder="Ingrese el valor"
              ></b-form-input>
            </b-form-group>
            <b-form-group v-else>
              <b-form-input
                type="text"
                v-model="sequenceOS"
                size="md"
                placeholder="Ingrese el valor"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12" class="my-1">
            <label class="text-grey">Estado</label>
            <b-form-group>
              <b-form-select
                v-model="selectedState"
                size="md"
                :options="optionsStates"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="4" class="my-1">
            <label class="text-grey">Tipos de fecha</label>
            <b-form-group>
              <b-form-select
                v-model="selectedFilterDate"
                size="md"
                :options="optionsDate"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col lg="4" class="my-1">
            <label class="text-grey">Fecha inicio</label>
            <b-form-input
              v-if="selectedFilterDate == 'a'"
              type="date"
              v-model="fechaInicioCreation"
            ></b-form-input>
            <b-form-input
              v-else
              type="date"
              v-model="fechaInicioEstimated"
            ></b-form-input>
          </b-col>
          <b-col lg="4" class="my-1">
            <label class="text-grey">Fecha fin</label>
            <b-form-input
              v-if="selectedFilterDate == 'a'"
              type="date"
              v-model="fechaFinCreation"
            ></b-form-input>
            <b-form-input
              v-else
              type="date"
              v-model="fechaFinEstimated"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="padding-ten-tb">
          <b-col xs="12" sm="12" md="12" lg="4" style="text-align:left">
            <b-button class="bg-grey-btn hidden-icon">
              <font-awesome-icon icon="download" /> Exportar
            </b-button>
            <b-button
              @click="getFilterData"
              class="bg-orange-btn width-1000 text-left padding-six-right"
            >
              <font-awesome-icon icon="search" /> Buscar
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <p>Resultados</p>
          </b-col>
        </b-row>
        
        <b-table
          class="hidden-xs"
          show-empty
          :busy="isBusy"
          small
          striped
          stacked="md"
          :items="itemTest"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :filterIncludedFields="filterOn"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="onFiltered"
          thead-class="hidden_header"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <b-button
              size="sm"
              @click="getDetails(row.item, $event.target)"
              class="mr-1 btn-orange-tra"
            >
              Ver detalle
            </b-button>
            <b-button
              size="sm"
              @click="trackingOS(row.item)"
              class="mr-1 btn-orange-tra"
            >
              Tracking
            </b-button>
          </template>
        </b-table>
        <b-table
          class="show-xs"
          show-empty
          :busy="isBusy"
          striped
          stacked="sm"
          :items="itemTest"
          :fields="fieldsTab"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :filterIncludedFields="filterOn"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="onFiltered"
          thead-class="hidden_header"
          responsive
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <b-card style="background:transparent">
              <b-row>
                <b-col cols="10" class="text-sm-right">
                  <label class="color-orange " for="">N° OS </label>
                  <span class="color-orange "
                    >{{ row.item.detalleSequenceId }}
                  </span>
                </b-col>
                <b-col cols="2" style="text-align:right">
                  <b-button
                    style="background:transparent;color:#545b62;border-color:transparent"
                    size="sm"
                    @click="row.toggleDetails"
                  >
                    <font-awesome-icon
                      :icon="row.detailsShowing ? 'chevron-up' : 'chevron-down'"
                    />
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </template>
          <template #row-details="row">
            <b-card style="background:transparent">
              <b-row>
                <b-col cols="6" class="text-sm-right">
                  <label class="text-grey" for="">Estado</label>
                  <span>{{ row.item.state }} </span></b-col
                >
                <b-col cols="6" class="text-sm-right">
                  <label class="text-grey" for="">Doc. Identidad</label>
                  <span>{{ row.item.identityDocument }} </span></b-col
                >
                <b-col cols="6" class="text-sm-right">
                  <label class="text-grey" for="">Fecha estimada</label>
                  <span>{{ row.item.estimatedDate }} </span></b-col
                >
                <b-col cols="6" class="text-sm-right">
                  <label class="text-grey" for="">Turno</label>
                  <span>{{ row.item.turn }} </span></b-col
                >
              </b-row>
            </b-card>
            <b-row>
              <b-col cols="12">
                <b-button
                  size="lg"
                  @click="getDetails(row.item, $event.target)"
                  class="mr-1 btn-orange-tra width-100"
                >
                  Ver detalle
                </b-button>
              </b-col>
              <b-col cols="12" class="margin-two-top">
                <b-button
                  size="lg"
                  @click="trackingOS(row.item)"
                  class="mr-1 btn-orange-tra width-100"
                >
                  Tracking
                </b-button>
              </b-col>
            </b-row>
          </template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          pills
          align="center"
          size="md"
          class="my-0"
        ></b-pagination>
      </b-container>
      
    </div>-->
  
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "Login",
  data() {
    return {
      fechaInicioCreation: "",
      fechaFinCreation: "",
      fechaFinEstimated: "",
      fechaInicioEstimated: "",
      optionsStates: [
        { value: "TODOS", text: "TODOS" },
        { value: "INGRESADA", text: "INGRESADA" },
        { value: "COORDINADA", text: "COORDINADA" },
        { value: "REALIZADA", text: "REALIZADA" },
      ],
      valueParams: "",
      sellerNote: "",
      sequenceOS: "",
      selectedParams: "a",
      selectedState: "TODOS",
      valueDate: "Hoy",
      optionsDate: [
        { value: "a", text: "Fecha de creación" },
        { value: "b", text: "Fecha estimada" },
      ],
      optionsParams: [
        { value: "a", text: "Doc. Identidad" },
        { value: "a", text: "RUC" },
        { value: "b", text: "Nota de venta" },
        { value: "c", text: "N° OS" },
      ],
      fechas: ["Hoy", "Ayer", "Tomatoes", "Corn"],
      isBusy: true,
      tag: "",
      itemTest: [],
      fields: [
        {
          key: "detalleSequenceId",
          label: "N° OS",
          sortable: true,
          sortDirection: "desc",
          thClass: " bg-orange",
        },
        {
          key: "state",
          label: "Estado",
          sortable: true,
          class: "text-center",
          thClass: " bg-orange",
        },
        {
          key: "identityDocument",
          label: "Doc. Identidad",
          thClass: " bg-orange",
        },
        { key: "estimatedDate", label: "F. Estimada", thClass: " bg-orange" },

        { key: "turn", label: "Turno", thClass: " bg-orange" },

        { key: "actions", label: "" },
      ],
      fieldsTab: [{ key: "actions", label: "" }],
      sortDirection: "asc",
      currentPage: 1,
      perPage: 10,
      pageOptions: [12, 22, 32],
      sortBy: "",
      sortDesc: false,
      selectedFilterDate: "b",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      dataDashboard: {},
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },

    rows() {
      return this.itemTest.length;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.itemTest.length;
  },
  created() {
    //this.getData();
    this.getDashboardData();
  },
  methods: {
    clearParamsVal() {
      this.valueParams = "";
      this.sellerNote = "";
      this.sequenceOS = "";
    },
    async getDashboardData() {
      this.$store.commit("SET_LOADING", true);
      try {
        let response = await axios.get("http://10.20.12.134:31604/dashboard");
        console.log(response);
        this.dataDashboard = response.data;
        //this.detailsOS = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
      }
    },
    async getFilterData() {
      try {
        this.$store.commit("SET_LOADING", true);
        let dateStart =
          this.fechaInicioCreation.length > 0
            ? encodeURI(this.fechaInicioCreation + " " + "00:00:00")
            : "";
        let dateEnd =
          this.fechaFinCreation.length > 0
            ? encodeURI(this.fechaFinCreation + " " + "00:00:00")
            : "";
        console.log(dateStart);
        let response = await axios.get(
          "http://10.20.12.134:31374/records?state=" +
            this.selectedState +
            "&identityDocument=" +
            this.valueParams +
            "&sellerNote=" +
            this.sellerNote +
            "&sequence=" +
            this.sequenceOS +
            "&limit=50&page=1&startCreationDate=" +
            dateStart +
            "&endCreationDate=" +
            dateEnd +
            "&startEstimatedDate=" +
            this.fechaInicioEstimated +
            "&endEstimatedDate=" +
            this.fechaFinEstimated
        );
        this.itemTest = response.data.map((user) => {
          return {
            id: user.id,
            detalleSequenceId: user.sequence,
            state: user.state,
            estimatedDate: user.estimatedDate,
            turn: user.turn,
            identityDocument: user.identityDocument,
          };
        });
        this.isBusy = false;
        //this.detailsOS = response.data;
      } catch (error) {
        this.isBusy = false;
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
      }
    },

    async getData() {
      this.$store.commit("SET_LOADING", true);
      try {
        let response = await axios.get(
          "http://10.20.12.134:31374/records?limit=50&offset=0"
        );
        this.itemTest = response.data.map((user) => {
          return {
            id: user.id,
            detalleSequenceId: user.sequence,
            state: user.state,
            estimatedDate: user.estimatedDate,
            turn: user.turn,
            identityDocument: user.identityDocument,
          };
        });
        this.isBusy = false;
        //this.detailsOS = response.data;
      } catch (error) {
        this.isBusy = false;
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
      }
    },
    onSubmit: function() {},
    async getDetails(item) {
      this.$store.commit("SET_LOADING", true);
      try {
        let response = await axios.get(
          "http://10.20.12.134:31374/summaries/" + item.detalleSequenceId
        );
        console.log(response);
        this.$store.commit("SET_DETAILS_OS", response.data);
        this.$router.push("/details");
        //this.detailsOS = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
      }
    },
    async trackingOS(item) {
      this.$store.commit("SET_LOADING", true);
      try {
        let response = await axios.get(
          "http://10.20.12.134:31374/tracking?sequence=" +
            item.detalleSequenceId
        );
        console.log(response);
        this.$store.commit("SET_TRACKING_OS", response.data);
        this.$router.push("/tracking");
        //this.detailsOS = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false)
      }
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>
<style scoped>
@media (max-width: 600px) {
  .hidden-xs {
    display: none !important;
  }
}
.center-div {
  position: absolute;
  position: relative;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.text-large {
  font-size: 25px;
}
.border-none {
  border-color: transparent;
}
.padding-ten-lr {
  padding: 10px;
  padding-left: 35px !important;
}

.text-left {
  text-align: left;
}
.hidden-icons {
  display: none;
}
.show-xs {
  display: none;
}

@media (max-width: 575.98px) {
  .card {
    border: none !important;
    width: 100%;
  }
  ::v-deep .table.b-table.show-xs > tbody > tr > [data-label] > div {
    width: 100% !important;
    display: inline-flex !important;
  }
}
@media (max-width: 645px) {
  .show-xs {
    visibility: visible;
  }
  .hidden-icon {
    display: none;
  }
  
  .show-icon {
    visibility: visible;
    padding-right: 4px;
  }
  table.b-table.b-table-stacked-md > tbody > tr > td > div {
    width: 100% !important;
    display: inline-flex !important;
  }
  .table.b-table.b-table-stacked-md > tbody > tr > div {
    width: 100% !important;
    display: inline-flex !important;
  }
}


.margin-two-top {
  margin-top: 10px;
}
.bg-grey-btn {
  background: #676767;
  color: white;
}

::v-deep .page-item.active .page-link {
  background: rgb(254, 123, 1);
  border-color: rgb(254, 123, 1);
}
::v-deep .table-striped tbody tr:nth-of-type(odd) {
  background-color: #fff8f2;
  border-color: transparent;
}
::v-deep .table td {
  border-color: transparent !important;
}
.card-body {
  padding: 0.75rem !important;
}
.btn-orange-tra {
  background: white;
  color: rgb(254, 123, 1);
  border-color: rgb(254, 123, 1);
}

::v-deep .b-table thead {
  background: rgb(254, 123, 1);
  color: white;
  font-weight: 400 !important;
}
::v-deep .b-table thead th {
  font-weight: 400 !important;
}
.text-center {
  text-align: center;
}
.text-grey {
  color: #676767;
  font-size: 15px;
  letter-spacing: 0px;
  display: block;
  margin-bottom: 0;
}
.bg-os-red {
  background: #dd4b39;
}
.bg-os-blue {
  background: #3c8dbc;
}
.bg-os-mostaza {
  background: #dc9212;
}
.bg-os-green {
  background: #00a65a;
}
.color-white {
  color: white;
}
.padding-five-all {
  margin: 15px;
  padding: 19px;
  border-radius: 10px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
}
.visibility-hidden {
  visibility: hidden;
}
.margin-lr-none {
  margin: 0 !important;
}
.padding-five-lr {
  margin: 15px;
}

.btn-secondary:focus {
  box-shadow: none;
}
.margin-none {
  margin: 0;
}
.color-orange {
  color: #ff7a00;
}
::v-deep .bg-orange {
  background: #ff7a00;
}
.hidden_header {
  visibility: hidden;
}

.color-gray {
  color: #676767;
  font-weight: bold;
}
.padding-six-right {
  margin-left: 20px;
}
.padding-ten-tb {
  padding-top: 25px;
  padding-bottom: 25px;
}
</style>
